<template>
  <div class="loading-screen" :class="background" :style="style">
    <img :src="loaderUrl" />
  </div>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';

export default {
  name: 'LoadingSpinner',
  props: {
    isBgSand: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loaderUrl() {
      if (this.isDesktop) {
        return assetURL('preloader.gif');
      }
      return assetURL('preloader_small.gif');
    },
    background() {
      if (this.isBgSand) {
        return 'u-bg--sand';
      }
      return '';
    },
    style() {
      if (this.isDesktop) {
        return 'min-height: 300px';
      }
      return 'position: absolute;';
    },
  },
};
</script>

<style>
.loading-screen {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
